// v2 ad/resource fetch — self-contained. Same endpoint as v1
// (GET /api/v1/resource/:hospitalId).
import axiosInstance from "../../lib/utils/axiosUtil";
import { baseURL } from "../../lib/utils/constants";

export interface AdResource {
  resource_id: string;
  resource_url: string;
  category: string; // "image" | "video"
  seqnum: number;
}

export const getAdResources = async (
  hospitalId: string
): Promise<AdResource[]> => {
  const res = await axiosInstance.get(`${baseURL}/resource/${hospitalId}`);
  const list = res?.data?.result ?? res?.data ?? [];
  return Array.isArray(list) ? list : [];
};
